// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.em-bivariate-nodata-label {
    font-size: 14px;
    dominant-baseline: middle;
}
.em-bivariate-tick-label {
    text-anchor: middle;
    font-size: 12px;
}
.em-bivariate-axis-title {
    font-size: 15px;
}
.em-bivariate-tick {
    stroke: #696969;
    stroke-width: 1;
}
.em-bivariate-frame {
    fill: none;
    stroke: #696969;
}
.em-bivariate-nodata {
    stroke: #696969;
    stroke-width: 0.5;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/css/legend/bivariate-choropleth.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;IACf,eAAe;AACnB;AACA;IACI,UAAU;IACV,eAAe;AACnB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB","sourcesContent":[".em-bivariate-nodata-label {\r\n    font-size: 14px;\r\n    dominant-baseline: middle;\r\n}\r\n.em-bivariate-tick-label {\r\n    text-anchor: middle;\r\n    font-size: 12px;\r\n}\r\n.em-bivariate-axis-title {\r\n    font-size: 15px;\r\n}\r\n.em-bivariate-tick {\r\n    stroke: #696969;\r\n    stroke-width: 1;\r\n}\r\n.em-bivariate-frame {\r\n    fill: none;\r\n    stroke: #696969;\r\n}\r\n.em-bivariate-nodata {\r\n    stroke: #696969;\r\n    stroke-width: 0.5;\r\n    cursor: pointer;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
